import React from "react";
import SC from "./style";

const TooltipText = ({
  maxLength = 0,
  title = "",
  style = {},
  onClick = () => {},
}) => {
  // Truncate the text if it exceeds the maxLength
  const truncatedText =
    maxLength > 0 && title && title.length > maxLength
      ? title.substring(0, maxLength) + "..."
      : title;

  return (
    <>
      <SC.TooltipText title={title} style={style} onClick={onClick}>
        {truncatedText}
      </SC.TooltipText>
    </>
  );
};

export default TooltipText;
